// extracted by mini-css-extract-plugin
export default {"wrapper":"wrapper--umuRO","Contained":"Contained--EIVW2","container":"container--lGjFs","list":"list--nt3Nq","fadeSlideUp":"fadeSlideUp--Zob5p"};